<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifb-competitor-name-input [fc]="form.get('name')" baseFilterItem></ifb-competitor-name-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option [value]="'true'">Active</mat-option>
        <mat-option [value]="'false'">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
